var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedViolatorYoureIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 378 378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 189,
    r: 189,
    fill: "#ef3829"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "202.02 71.14 218.39 38.3 171.18 86.17 184.61 86.17 164.65 110.27 180.44 109.85 159.61 145.32 214.23 92.42 198.79 92.42 215.98 70.99 202.02 71.14",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m83.05,222.45l3.73-8.15c1.68.92,3.2,1.52,4.34,1.52,2.13,0,3.81-1.07,4.8-3.43l1.6-3.81-17.22-37.72h11.05l10.82,26.37,10.36-26.37h11.05l-17.3,41.38c-3.28,7.7-6.02,12.88-14.33,12.88-2.74,0-6.32-1.22-8.92-2.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.96,189.91c0-11.73,8.23-19.96,19.81-19.96s19.89,8.23,19.89,19.96-8.15,19.96-19.74,19.96-19.96-8.23-19.96-19.96Zm29.41,0c0-6.25-3.96-10.67-9.6-10.67s-9.53,4.42-9.53,10.67,3.96,10.67,9.68,10.67,9.45-4.42,9.45-10.67Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.74,200.43c5.26.08,8.08-3.28,8.08-9.6v-19.97h10.06v38.1h-9.45l-.46-5.11c-2.51,3.89-6.32,6.02-11.13,6.02-9.07,0-14.25-5.33-14.25-17.45v-21.56h10.06v19.51c0,7.7,2.82,9.98,7.09,10.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.86,155.62h10.44l-7.47,17.98h-7.62l4.65-17.98Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.25,170.86h10.06v7.01c3.12-4.8,8.31-7.16,13.49-7.16v9.75c-7.01,0-13.49,2.51-13.49,8.46v20.04h-10.06v-38.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.07,189.91c0-11.73,8.23-19.96,19.81-19.96,9.98,0,18.59,8.15,18.59,22.63h-27.89c.46,5.18,4.95,8.31,9.83,8.31,4.19,0,6.71-1.98,8.15-4.8l8.99,3.5c-3.28,6.48-9.22,10.29-18.21,10.29-11.28,0-19.28-8.23-19.28-19.96Zm11.05-4.8h16.46c-.46-4.8-4.72-6.63-8-6.63s-7.92,1.83-8.46,6.63Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.68,232.53c0-3.12,2.67-5.79,5.79-5.79s5.79,2.67,5.79,5.79-2.67,5.79-5.79,5.79-5.79-2.67-5.79-5.79Zm.76,11.96h10.06v38.1h-10.06v-38.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.8,244.5h9.45l.46,5.11c2.51-3.89,6.4-6.02,11.2-6.02,9.07,0,14.25,5.33,14.17,17.45v21.57h-10.06v-19.51c0-7.7-2.82-9.98-7.09-10.06-5.26-.08-8.08,3.28-8.08,9.6v19.96h-10.06v-38.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.53,277.65c0-3.35,2.82-6.1,6.1-6.1s6.1,2.74,6.1,6.1-2.74,6.1-6.1,6.1-6.1-2.74-6.1-6.1Zm.53-48.39h11.13l-.69,35.97h-9.75l-.69-35.97Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedViolatorYoureIn);
export default __webpack_public_path__ + "static/media/Red-Violator-Youre-In.8aaa1ed074f4e0ed0e14d50b726dfa77.svg";
export { ForwardRef as ReactComponent };